/* eslint-disable no-case-declarations */
import * as R from 'ramda'
import React from 'react'
import useIsBrowser from 'hooks/useIsBrowser'

import RoundButton from 'components/UI/RoundButton'

export const DefaultComponent = () => <div>DefaultComponent</div>

export const renderComponent = (componentSelector, content) => {
  switch (componentSelector) {
    case 'ContentfulCallToAction':
      const callToActionLink = R.pathOr('', ['callToActionLink'], content)
      const callToActionText = R.pathOr('', ['callToActionText'], content)
      const callToActionVariation = R.pathOr('', ['variation'], content)

      // Check if the link starts with 'mailto:'
      const isEmailLink = callToActionLink.toLowerCase().startsWith('mailto:')
      const isHttpsLink = callToActionLink.toLowerCase().startsWith('https://')
      const isExternalLink = /^(https?:\/\/|mailto:|tel:)/i.test(
        callToActionLink,
      )
      const isWebsiteURL = callToActionLink.includes('.')

      const extractPathSegments = pathname => {
        const segments = pathname
          .split('/')
          .filter(segment => segment.trim() !== '')

        // Extract the first two segments
        const extractedPath = `/${segments.slice(0, 2).join('/')}`

        return extractedPath
      }

      const pathSegment =
        useIsBrowser && extractPathSegments(window.location.pathname)

      const renderLink = link => {
        if (isEmailLink) {
          return link
        }
        if (isWebsiteURL && isHttpsLink) {
          return link
        }
        if (isWebsiteURL && !isHttpsLink) {
          return `//${link}`
        }
        if (!isWebsiteURL) {
          return `${pathSegment}/${link}`
        }

        return link
      }

      return (
        <RoundButton
          isCentered
          isExternal={isExternalLink}
          href={renderLink(callToActionLink)}
          variation={callToActionVariation}
        >
          {callToActionText}
        </RoundButton>
      )

    default:
      return null
  }
}
